.header {
  padding: 1rem 1.5rem !important;
}

.title {
  font-weight: 600 !important;
  font-size: 1.25rem !important;

  color: var(--mantine-color-primary-7);
}

.body {
  padding: 0.75rem 1.5rem 1.5rem !important;
}
